import NiceModal from '@ebay/nice-modal-react';

import { useSelector } from 'react-redux';

import Icon from 'components/global/Icon';
import Image from 'components/global/Image';
import Modal from 'components/global/Modal';
import Tooltip from 'components/global/Tooltip';
import Typography from 'components/global/Typography';
import { ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import { faArrowRotateLeft } from '@fortawesome/pro-solid-svg-icons';

import * as S from './LogoViewer.styled';

/**
 * @author @buunsal
 */
const ImageModal = NiceModal.create(({ name, url }) => (
	<Modal closeButton fullwidth maxWidth="medium" className="modal-productImage">
		<ModalTitle>
			<Typography variant="p1">{name}</Typography>
		</ModalTitle>
		<ModalContent>
			<Image url={url} width="100%" height="50rem" style={{ objectFit: 'contain', borderRadius: '4px' }} />
		</ModalContent>
	</Modal>
));

export const ProductLogoViewer = ({ data }) => {
	const url = data?.imageURL;
	const {
		darkMode,
		localization: { dir }
	} = useSelector((state) => state.layout);
	const defaultImage = darkMode
		? 'https://storage.googleapis.com/tryoto-public/public/assets/images/emptyProduct-darkMode.png'
		: 'https://storage.googleapis.com/tryoto-public/public/assets/images/emptyProduct.jpg';

	return (
		<S.Container>
			<S.ImageContainer>
				<Image
					url={url}
					width={dir === 'rtl' ? '4.5rem' : '3.5rem'}
					height={dir === 'rtl' ? '4.5rem' : '3.5rem'}
					style={{ objectFit: 'contain', borderRadius: '4px' }}
					defaultUrl={defaultImage}
					onClick={() => {
						url && NiceModal.show(ImageModal, { name: data?.name, url });
					}}
				/>
			</S.ImageContainer>
			<Typography autoTranslation={false}>{data?.name}</Typography>
		</S.Container>
	);
};

export const BrandLogoViewer = ({ data }) => {
	const darkMode = useSelector((state) => state.layout.darkMode);
	const defaultImage = darkMode
		? 'https://storage.googleapis.com/tryoto-public/public/assets/images/emptyBrand-darkMode.png'
		: 'https://storage.googleapis.com/tryoto-public/public/assets/images/emptyBrand.png';
	const url = data?.brandLogo;

	return (
		<S.Container>
			<S.ImageContainer>
				{url ? (
					<Image
						url={url ?? null}
						style={{ objectFit: 'contain', borderRadius: '4px' }}
						defaultUrl={defaultImage}
						onClick={() => {
							url &&
								NiceModal.show(ImageModal, {
									name: data?.storeName ?? data?.brandName,
									url
								});
						}}
						height="3.5rem"
						width="3.5rem"
					/>
				) : null}
			</S.ImageContainer>
			<Typography autoTranslation={false}>{data?.storeName ?? data?.brandName}</Typography>
		</S.Container>
	);
};

export const SalesChannelLogoViewer = ({ data }) => {
	const darkMode = useSelector((state) => state.layout.darkMode);
	const defaultImage = darkMode
		? 'https://storage.googleapis.com/tryoto-public/public/assets/images/emptySalesChannel-darkMode.png'
		: 'https://storage.googleapis.com/tryoto-public/public/assets/images/emptySalesChannel.png';

	return (
		<S.Container>
			<S.ImageContainer>
				{data?.salesChannelLogo && (
					<Image
						url={data?.salesChannelLogo ?? null}
						style={{ objectFit: 'contain', borderRadius: '4px' }}
						defaultUrl={defaultImage}
						height="3.5rem"
						width="3.5rem"
					/>
				)}
			</S.ImageContainer>
			<Typography autoTranslation={false}>{data?.salesChannelName}</Typography>
		</S.Container>
	);
};

export const DCLogoViewer = ({ data }) => {
	const darkMode = useSelector((state) => state.layout.darkMode);
	const defaultImage = darkMode
		? 'https://storage.googleapis.com/tryoto-public/public/assets/images/emptyDC-darkMode.png'
		: 'https://storage.googleapis.com/tryoto-public/public/assets/images/emptyDC.png';

	return (
		<S.Container>
			<S.ImageContainer>
				{data?.deliveryCompanyLogo && (
					<Image
						url={data?.deliveryCompanyLogo ?? null}
						style={{ objectFit: 'contain', borderRadius: '4px' }}
						defaultUrl={defaultImage}
						height="3.5rem"
						width="3.5rem"
					/>
				)}
			</S.ImageContainer>
			<Typography>{data?.deliveryName}</Typography>
			{data?.isReverseShipment === 'yes' && (
				<Tooltip title="thisIsReturnShipment">
					<Icon size="x-small" icon={faArrowRotateLeft} />
				</Tooltip>
			)}
		</S.Container>
	);
};

export const DeliveryCompanyLogoViewer = ({ data }) => {
	const darkMode = useSelector((state) => state.layout.darkMode);
	const defaultImage = darkMode
		? 'https://storage.googleapis.com/tryoto-public/public/assets/images/emptyDC-darkMode.png'
		: 'https://storage.googleapis.com/tryoto-public/public/assets/images/emptyDC.png';

	return (
		<S.Container>
			<S.ImageContainer>
				{data?.icon && (
					<S.DCImage>
						<Image url={data?.icon ?? null} defaultUrl={defaultImage} />
					</S.DCImage>
				)}
			</S.ImageContainer>
			<Typography>{data?.name}</Typography>
		</S.Container>
	);
};
